import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBellRing = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.06088 4.6344C6.07213 5.18345 5.25715 5.99876 4.7085 6.98773"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.2619 2C5.24714 2.28851 4.32295 2.83158 3.57705 3.57765C2.83115 4.32371 2.28829 5.24803 2 6.26286"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.85718 17.7143H19.1429"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1429 17.7142C19.1429 17.7142 17.7143 16.4704 17.7143 11.9999C17.7143 8.42846 15.2743 5.26846 12 5.26846C8.72575 5.26846 6.28575 8.42846 6.28575 11.9999C6.28575 16.4942 4.85718 17.7142 4.85718 17.7142"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4287 20.5714C13.4287 20.9503 13.2782 21.3137 13.0103 21.5816C12.7423 21.8495 12.379 22 12.0001 22C11.6212 22 11.2579 21.8495 10.99 21.5816C10.722 21.3137 10.5715 20.9503 10.5715 20.5714"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 5.26856V3.42856"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.939 4.6344C17.4301 4.90862 17.8813 5.24893 18.2799 5.64583C18.6775 6.04422 19.0179 6.49582 19.2913 6.98773"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.738 2C18.7528 2.28851 19.677 2.83158 20.4229 3.57765C21.1688 4.32371 21.7117 5.24803 21.9999 6.26286"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBellRing.displayName = 'SvgBellRing';
export default SvgBellRing;
